import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../../../components/BusComponent';
import VisibilityToggle from '../../form/VisibilityToggle';
import Popover from '../../popover/Popover';
import DealListDropdownItem from './DealListDropdownItem';

class DealListDropdown extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isPopoverVisible: false,
            activeDealList: null,
            dealLists: [],
        };

        this.bindGluBusEvents({
            ACTIVE_DEAL_LIST: this.onActiveDealList,
            DEAL_LISTS: this.onDealLists,
            DEAL_LISTS_LOAD_SUCCESS: this.onDealLists,
            USER_PREFERENCES_GET_SUCCESS: this.onUserPreferencesGetSuccess,
        });
    }

    componentDidMount() {
        this.emit('ACTIVE_DEAL_LIST_GET_REQUEST');
        this.emit('DEAL_LISTS_GET_REQUEST');
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onActiveDealList = ({ dealList }) => {
        this.setState({ activeDealList: dealList });
    };

    onDealLists = ({ dealLists }) => {
        this.setState({ dealLists });
    };

    onUserPreferencesGetSuccess = () => {
        this.emit('ACTIVE_DEAL_LIST_GET_REQUEST');
        this.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
    };

    togglePopover = () => {
        this.setState(prev => ({
            isPopoverVisible: !prev.isPopoverVisible,
        }));
    };

    closePopover = () => {
        this.setState({ isPopoverVisible: false });
    };

    updateActiveList = dealList => {
        if (!dealList) return;

        this.emit('USER_PREFERENCES_UPDATE_REQUEST', {
            my_deals_active_list: {
                id: dealList.id,
                name: dealList.name,
            },
        });
    };

    handleSelect = list => {
        this.updateActiveList(list);
        this.closePopover();
    };

    renderPopoverContent = () => {
        const { dealLists, activeDealList } = this.state;
        const { intl } = this.props;

        return (
            <div className="deal-list-dropdown-container__popover" ref={this.setPopoverRef}>
                <div className="deal-list-dropdown-container__popover-header">
                    {intl.formatMessage({ id: 'dataBrowser.selectList' })}
                </div>

                <div className="deal-list-dropdown-container__list">
                    {dealLists.map(dealList => (
                        <DealListDropdownItem
                            key={dealList.id}
                            item={dealList}
                            isSelected={activeDealList && dealList.id === activeDealList.id}
                            onClick={() => this.handleSelect(dealList)}
                        />
                    ))}
                </div>
            </div>
        );
    };

    render() {
        const { onVisibilityToggle, isVisible, hideVisibilityToggle } = this.props;
        const { isPopoverVisible, activeDealList } = this.state;

        const dealListName = activeDealList ? activeDealList.name : 'Select a list';
        return (
            <div className="deal-list-dropdown-container">
                <button
                    ref={el => (this.trigger = el)}
                    disabled={!isVisible}
                    onClick={this.togglePopover}
                    className={`deal-list-dropdown-container__dropdown-container ${!isVisible ? 'hidden-deals' : ''}`}
                >
                    <h5 className="deal-list-dropdown-container">{dealListName}</h5>
                    <i className="material-icons-outlined">arrow_drop_down</i>
                </button>

                {!hideVisibilityToggle && (
                    <VisibilityToggle
                        onClick={onVisibilityToggle}
                        visible={isVisible}
                        className="geo-json-library-legend__visibility-toggle"
                        testId="deal-pins-visibility-toggle"
                        iconClassName="material-icons-outlined"
                    />
                )}
                <Popover
                    open={isPopoverVisible}
                    anchorEl={this.trigger}
                    onCloseRequest={this.closePopover}
                    marginTop={8}
                    className="deal-list-dropdown-container__popover"
                >
                    {this.renderPopoverContent()}
                </Popover>
            </div>
        );
    }
}

DealListDropdown.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    isVisible: PropTypes.bool,
    onVisibilityToggle: PropTypes.func,
    hideVisibilityToggle: PropTypes.bool,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(DealListDropdown);
